<template>
  <section class="section">
    <h1 class="title">Clients</h1>
    <div class="columns">
      <div class="column is-one-quarter">
        <b-field label="Client">
          <b-select
            placeholder="Select client"
            @input="onChangeClient($event)"
            v-model="client"
            expanded
          >
            <option
              v-for="(client, index) in clientsMainAccount"
              :key="index"
              :value="client.clientCode"
            >
              {{ client.clientName + " (" + client.clientCode + ")" }}
            </option>
          </b-select>
        </b-field>
        <b-field v-if="showAccountSelect" label="Account">
          <b-select
            placeholder="Select account"
            @input="onChangeAccount($event)"
            v-model="account"
            v-if="showAccountSelect"
            expanded
          >
            <option
              v-for="(account, index) in accounts"
              :key="index"
              :value="account.accountCode"
            >
              {{ account.accountCode }}
            </option>
          </b-select>
        </b-field>
        <!--<div class="columns" >
          <b-select >
            <option v-for="(client, index) in accountsx" :key="index" :value="client.clientCode">
              {{ client.clientName + ' (' + client.clientCode + ')' }}
            </option>
          </b-select>
        </div>-->
        <b-field grouped>
          <div class="control">
            <b-button @click="addClient">Add New Client</b-button>
          </div>
          <div class="control">
            <b-button @click="addAccount" v-if="showNewAccount"
              >Add New Account</b-button
            >
          </div>
        </b-field>
        <!-- <div class="column is-one-half" >
        <b-field label="Find client">
            <b-autocomplete
                v-model="clientX"
                :data="loadClients"
                placeholder=""
                field="client"
                :loading="isFetching"
                @select="option => selected = option.clientCode">
            </b-autocomplete>
        </b-field>
         <p class="content"> {{ selected }}</p>
      </div>
      <div class="columns">
              <div class="column is-one-fifth">
                <b-checkbox v-model="searchAgent">Agent</b-checkbox>
              </div>
            </div>-->
      </div>
      <div class="column is-8">
        <section class="section is-main-section">
          <b-tabs
            v-model="clientTab"
            @input="tabSelectClient"
            v-if="showClientTab"
          >
            <b-tab-item label="Client Details">
              <form @submit.prevent="submitClientDetails">
                <b-input v-model="form.accountId" type="hidden" />
                <b-input v-model="form.status" type="hidden" />
                <b-input v-model="form.columnPrefix" type="hidden" />
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Client Code">
                      <b-input v-model="form.code" id="code" disabled />
                    </b-field>
                  </div>
                  <div class="column is-two-fifths">
                    <b-field label="Client Name">
                      <b-input
                        v-model="form.name"
                        id="name"
                        :disabled="isDisabled"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <h3 class="title is-5">Postal Address</h3>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Name">
                      <b-input
                        v-model="form.postalName"
                        id="postalName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Street Address">
                      <b-input
                        v-model="form.postalAddress"
                        id="postalAddress"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Suburb">
                      <b-input
                        v-model="form.postalSuburb"
                        id="postalSuburb"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Postcode">
                      <b-input
                        v-model="form.postalPostcode"
                        id="postalPostcode"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Client PIC">
                      <b-input
                        v-model="form.clientPic"
                        id="clientPic"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Client LPA">
                      <b-input
                        v-model="form.clientLpaNum"
                        id="clientLpaNum"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-checkbox v-model="form.isAgent">Agent</b-checkbox>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Contact Details">
              <form @submit.prevent="submitClientDetails">
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Office Phone">
                      <b-input
                        v-model="form.phoneNumber"
                        id="phoneNumber"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-two-fifths">
                    <b-field label="Alt Office Phone">
                      <b-input
                        v-model="form.altphoneNumber"
                        id="altPhoneNumber"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Mobile">
                      <b-input
                        v-model="form.mobileNumber"
                        id="mobileNumber"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-two-fifths">
                    <b-field label="Fax">
                      <b-input v-model="form.faxNumber" id="faxNumber" />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Email 1">
                      <b-input
                        type="email"
                        v-model="form.emailAddress"
                        id="emailAddress"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Email 2">
                      <b-input
                        type="email"
                        v-model="form.altEmailAddress"
                        id="altEmailAddress"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Contact Name 1">
                      <b-input
                        v-model="form.contactName"
                        id="contactName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Contact Phone 1">
                      <b-input
                        v-model="form.contactPhone"
                        id="contactPhone"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Contact Name 2">
                      <b-input
                        v-model="form.altContactName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Contact Phone 2">
                      <b-input
                        v-model="form.altContactPhone"
                        id="altContactPhone"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Finance Contact Name ">
                      <b-input
                        v-model="form.financeContactName"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Finance Contact Phone">
                      <b-input
                        v-model="form.financeContactPhone"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Finance Email">
                      <b-input
                        type="email"
                        v-model="form.financeEmail"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Sales Contact Name ">
                      <b-input
                        v-model="form.salesContactName"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Sales Contact Phone">
                      <b-input
                        v-model="form.salesContactPhone"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Sales Email">
                      <b-input
                        type="email"
                        v-model="salesEmail"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Property Address">
              <form @submit.prevent="submitClientDetails">
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Address Name">
                      <b-input
                        v-model="form.addressName"
                        id="addressName"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Street Address">
                      <b-input
                        v-model="form.address"
                        id="address"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Suburb">
                      <b-input
                        v-model="form.town"
                        id="town"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Postcode">
                      <b-input
                        v-model="form.postcode"
                        id="postcode"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="GPS">
                      <b-input
                        v-model="form.gps"
                        id="gps"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="PIC">
                      <b-input
                        v-model="form.pic"
                        id="pic"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="LPA">
                      <b-input
                        v-model="form.lpaNum"
                        id="lpaNum"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Bank Details">
              <form @submit.prevent="submitClientDetails">
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Bank Name">
                      <b-input
                        v-model="form.bankName"
                        id="bankName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Account Name">
                      <b-input
                        v-model="form.bankAccName"
                        id="bankAccName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="BSB">
                      <b-input
                        v-model="form.bankBsb"
                        id="bankBsb"
                        required
                        @blur="checkClientForm"
                        validation-message="Please enter a valid BSB"
                        pattern="\d{3}(-?|\s?)\d{3}"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Account Number">
                      <b-input
                        v-model="form.bankAcc"
                        id="bankAcc"
                        required
                        @blur="checkClientForm"
                        validation-message="Please enter 6 to 10 digits for the account number"
                        pattern="^[0-9]{6,10}$"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Trading Details">
              <form @submit.prevent="submitClientDetails">
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Trading Name">
                      <b-input
                        v-model="form.tradingName"
                        id="tradingName"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="ABN">
                      <b-input
                        v-model="form.tradingAbn"
                        id="tradingAbn"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="field">
                  <b-checkbox v-model="form.gstRegistered"
                    >GST Registered</b-checkbox
                  >
                </div>
                <div class="field">
                  <b-checkbox v-model="hobbyrec"
                    >Hobby Dec Registered</b-checkbox
                  >
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Hobby Dec Type">
                      <b-input
                        v-model="form.hobbyDecType"
                        id="hobbyDecType"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Hobby Dec Ref">
                      <b-input
                        v-model="form.hobbyDecRef"
                        id="hobbyDecRef"
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Agent Details">
              <form @submit.prevent="submitClientDetails">
                <div v-if="errors.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agent Code">
                      <b-input
                        v-model="form.agent"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Agent name">
                      <b-input
                        v-model="form.agentName"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agent Rep">
                      <b-input
                        v-model="form.rep"
                        required
                        @blur="checkClientForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isClientSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Client</b-button
                  >
                </div>
              </form>
            </b-tab-item>
          </b-tabs>

          <b-tabs
            v-model="accountTab"
            @input="tabSelectAccount"
            v-if="showAccountTab"
          >
            <b-tab-item label="Account Details">
              <form @submit.prevent="submitAccountDetails">
                <b-input v-model="aform.accountId" type="hidden" />
                <b-input v-model="aform.status" type="hidden" />
                <b-input v-model="aform.columnPrefix" type="hidden" />
                <b-input id="aform.addAccount" type="hidden" />
                <b-input v-model="aform.slCode" type="hidden" />
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Client Code">
                      <b-input v-model="aform.code" id="aCode" disabled />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Account Code">
                      <b-input
                        v-model="aform.accountCode"
                        id="aAccountCode"
                        disabled
                      />
                    </b-field>
                  </div>
                  <div class="column is-two-fifths">
                    <b-field label="Account Name">
                      <b-input
                        v-model="aform.accountName"
                        id="aAccountName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <h3 class="title is-5">Postal Address</h3>
                <div class="columns">
                  <div class="column is-half">
                    <div class="field">
                      <b-checkbox
                        v-model="aform.useClientAddress"
                        @input="useClientAddress"
                        >Use Client Address details</b-checkbox
                      >
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Name">
                      <b-input
                        v-model="aform.postalName"
                        id="aPostalName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Street Address">
                      <b-input
                        v-model="aform.postalAddress"
                        id="aPostalAddress"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Suburb">
                      <b-input
                        v-model="aform.postalSuburb"
                        id="aPostalSuburb"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Postcode">
                      <b-input
                        v-model="aform.postalPostcode"
                        id="aPostalPostcode"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agents Client Name">
                      <b-input v-model="aform.endClientName" />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Agents Client PIC">
                      <b-input v-model="aform.endClientPic" />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isAccountSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Contact Details">
              <form @submit.prevent="submitAccountDetails">
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errorsAccount" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Contact Name">
                      <b-input
                        v-model="aform.contactName"
                        id="aContactName"
                        required
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Contact Phone">
                      <b-input
                        v-model="aform.contactPhone"
                        id="aContactPhone"
                        required
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div></div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Email">
                      <b-input
                        type="email"
                        v-model="aform.emailAddress"
                        id="aEmailAddress"
                        @blur="checkAccountForm"
                        required
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Contact Name 2">
                      <b-input
                        type="text"
                        v-model="aform.altContactName"
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Contact Phone 2">
                      <b-input
                        v-model="aform.altContactPhone"
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Email Contact 2">
                      <b-input
                        type="email"
                        v-model="aform.altEmailAddress"
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Finance Contact Name ">
                      <b-input
                        v-model="aform.financeContactName"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Finance Contact Phone">
                      <b-input
                        v-model="aform.financeContactPhone"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Finance Email">
                      <b-input
                        type="email"
                        v-model="aform.financeEmail"
                        @blur="checkAccountForm"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Sales Contact Name ">
                      <b-input
                        v-model="aform.salesContactName"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Sales Contact Phone">
                      <b-input
                        v-model="aform.salesContactPhone"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Sales Email">
                      <b-input type="email" v-model="aform.salesEmail" />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    native-type="submit"
                    v-if="isAccountSaveEnabled"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Property Address">
              <form @submit.prevent="submitAccountDetails">
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errorsAccount" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Address Name">
                      <b-input
                        v-model="aform.addressName"
                        id="aAddressName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Street Address">
                      <b-input
                        v-model="aform.address"
                        id="aAddress"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Suburb">
                      <b-input
                        v-model="aform.town"
                        id="aTown"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Postcode">
                      <b-input
                        v-model="aform.postcode"
                        id="aPostcode"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="GPS">
                      <b-input
                        v-model="aform.gps"
                        id="agps"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="PIC">
                      <b-input
                        v-model="aform.pic"
                        id="aPic"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="LPA">
                      <b-input
                        v-model="aform.lpaNum"
                        id="aLpaNum"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isAccountSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Bank Details">
              <form @submit.prevent="submitAccountDetails">
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errorsAccount" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-checkbox
                      v-model="aform.useClientBank"
                      @input="useClientBank"
                      >Use Client Bank Account</b-checkbox
                    >
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Bank Name">
                      <b-input
                        v-model="aform.bankName"
                        id="aBankName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-half">
                    <b-field label="Account Name">
                      <b-input
                        v-model="aform.bankAccName"
                        id="aBankAccName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="BSB">
                      <b-input
                        v-model="aform.bankBsb"
                        id="aBankBsb"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Account Number">
                      <b-input
                        v-model="aform.bankAcc"
                        id="aBankAcc"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isAccountSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Trading Details">
              <form @submit.prevent="submitAccountDetails">
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errorsAccount" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="column is-half">
                  <b-checkbox
                    v-model="aform.useClientBusinessDetails"
                    @input="useClientBusiness"
                    >Use Client Business Details</b-checkbox
                  >
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Trading Name">
                      <b-input
                        v-model="aform.tradingName"
                        id="aTradingName"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="ABN">
                      <b-input
                        v-model="aform.tradingAbn"
                        id="aTradingAbn"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="field">
                  <b-checkbox
                    v-model="aform.gstRegistered"
                    @blur="checkAccountForm"
                    >GST Registered</b-checkbox
                  >
                </div>
                <div class="field">
                  <b-checkbox>Hobby Dec Registered</b-checkbox>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Hobby Dec Type">
                      <b-input
                        v-model="aform.hobbyDecType"
                        id="aHobbyDecType"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                  <div class="column is-one-fifth">
                    <b-field label="Hobby Dec Ref">
                      <b-input
                        v-model="aform.hobbyDecRef"
                        id="aHobbyDecRef"
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isAccountSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>

            <b-tab-item label="Other Details">
              <form @submit.prevent="submitAccountDetails">
                <div v-if="errorsAccount.length" class="column is-one-third">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agent">
                      <b-input v-model="aform.agent" />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agent Name">
                      <b-input
                        v-model="aform.agentName"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Agent Rep">
                      <b-input
                        v-model="aform.rep"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Stock Carrier">
                      <b-input
                        v-model="aform.stockCarrier"
                        id="stockCarrier"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-fifth">
                    <b-field label="Notes">
                      <b-input
                        v-model="aform.notes"
                        id="notes"
                        type="textarea"
                        required
                        @blur="checkAccountForm"
                      />
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="control">
                  <b-button
                    v-if="isAccountSaveEnabled"
                    native-type="submit"
                    type="is-primary"
                    >Save Account</b-button
                  >
                </div>
              </form>
            </b-tab-item>
          </b-tabs>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import mapValues from "lodash/mapValues";
import axios from "axios";

export default {
  name: "Forms",
  components: {},
  props: {
    id: {
      default: null
    }
  },
  data() {
    return {
      searchAgent: true,
      clientX: null,
      clientsx: [],
      selected: null,
      clientTab: "",
      accountTab: "",
      isLoading: false,
      showAccountTab: false,
      showNewAccount: false,
      showClientTab: true,
      showAccountSelect: false,
      isClientSaveEnabled: false,
      isAccountSaveEnabled: false,
      isDisabled: false,
      clientCode: null,
      isFetching: false,
      accounts: [],
      accountsx: [],
      account: null,
      form: { clientCode: null },
      aform: { clientCode: null },
      code: null,
      name: null,
      isAgent: false,
      postalName: null,
      postalAddress: null,
      postalSuburb: null,
      postalPostcode: null,
      phoneNumber: null,
      altPhoneNumber: null,
      mobileNumber: null,
      faxNumber: null,
      emailAddress: null,
      altEmailAddress: null,
      financeEmail: null,
      salesEmail: null,
      contactName: null,
      contactPhone: null,
      altContactName: null,
      altContactPhone: null,
      financeContactName: null,
      financeContactPhone: null,
      salesContactName: null,
      salesContactPhone: null,
      clientPic: null,
      clientLpaNum: null,
      bankName: null,
      bankAccName: null,
      bankBsb: null,
      bankAcc: null,
      tradingName: "",
      tradingAbn: "",
      gstRegistered: null,
      hobbyDecType: "",
      hobbyDecRef: "",
      agent: null,
      agentName: null,
      is_agent: false,
      agentRep: null,
      rep: null,
      status: null,
      addressName: null,
      address: null,
      town: null,
      postcode: null,
      gps: null,
      pic: null,
      columnPrefix: null,
      accountId: null,
      client: null,
      altphoneNumber: null,
      lpaNum: null,
      hobbyrec: false,
      clients: [],
      errors: [],
      errorsAccount: [],
      btnDisable: true,
      center: { lat: -34.92123, lng: 138.599503 },
      markers: [],
      places: [],
      currentPlace: null
    };
  },
  computed: {
    clientsMainAccount() {
      return this.clients.filter(client => client.accountCode === "-");
    },
    loadClients() {
      return this.clientsx.filter(option => {
        return option.client.toString().toLowerCase();
      });
    }
  },
  methods: {
    mark(event) {
      console.log(event.latLng.lat());
      console.log(event.latLng.lng());
    },
    async getClients() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "client_account/account_code_list",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.clients = data;
        /*  var foundx = this.clients.filter(function (clientsz) {
          return clientsz.accountCode === '1'
        })
        this.clientsx = foundx */
        var i = 0;
        for (i = 0; i < data.length; i++) {
          this.clientsx.push({
            client:
              data[i].accountCode +
              ":" +
              data[i].clientName +
              ":" +
              data[i].clientCode,
            accountCode: data[i].accountCode,
            clientCode: data[i].clientCode
          });
        }
        // this.sortArrays()
      } catch (error) {
        console.log(error);
      }
    },
    sortArrays() {
      // xxx.orderBy(this.clientsx, ['accountCode', 'clientCode'], ['desc', 'desc'])
      // alert(this.clientsx[0].client)
      this.clientsx.sort((a, b) => a.client.localeCompare(b.client));
    },
    async getClient(clientCode) {
      // get client details from clients array
      var found = this.clients.filter(function(search) {
        return search.clientCode === clientCode;
      });
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "client/" + found[0].clientCode,
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token")
            }
          }
        );
        this.clearClientForm();
        this.form = data[0];
        this.form.code = data[0].code;
        this.form.name = data[0].name;
        this.form.address = data[0].defaultAddress.address;
        this.form.addressName = data[0].defaultAddress.addressName;
        this.form.town = data[0].defaultAddress.town;
        this.form.postcode = data[0].defaultAddress.postcode;
        this.form.gps = data[0].defaultAddress.gps;
        this.form.pic = data[0].defaultAddress.pic;
        if (data[0].hobbyDecType !== "" || data[0].hobbyDecRef !== "") {
          this.hobbyrec = true;
        } else {
          this.hobbyrec = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAccount(accountCode) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "client_account/" +
            this.form.code +
            "." +
            accountCode,
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.aform = data[0];
        this.aform.code = data[0].clientCode;
        this.aform.accountName = data[0].accountName;
        this.aform.addressName = data[0].address.addressName;
        this.aform.town = data[0].address.town;
        this.aform.postcode = data[0].address.postcode;
        this.aform.gps = data[0].address.gps;
        this.aform.pic = data[0].address.pic;
        this.aform.address = data[0].address.address;
        this.showAccountTab = true;
        this.showClientTab = false;
      } catch (error) {
        console.log(error);
      }
    },
    getClientData(clientCode) {
      // const found = this.clients.filter(({ clientCode }) => this.clients.clientCode === clientCode)
      var found = this.clients.filter(function(accounts) {
        return accounts.clientCode === clientCode;
      });
      var foundx = this.clients.filter(function(accountsx) {
        return accountsx.accountCode === "1";
      });
      var foundxx = foundx.filter(function(accountsx) {
        return accountsx.clientCode === "ADATK";
      });
      this.accountsx = foundxx;
      this.showAccountSelect = true;
      this.accounts = found;
      this.getClient(clientCode);
    },
    tabSelectClient: function(index) {
      return index;
      // if (index === 1) alert("Index 2 is the third button");
      // alert(this.form.code);
    },
    tabSelectAccount: function(index) {
      return index;
      // if (index === 2) alert("Index 2 is the third button");
    },
    reset() {
      this.form = mapValues(this.form, item => {
        if (item && typeof item === "object") {
          return [];
        }
        return null;
      });

      this.$buefy.snackbar.open({
        message: "Reset successfully",
        queue: false
      });
    },
    onChangeClient(clientCode) {
      this.account = null;
      this.getClientData(clientCode);
      this.showAccountTab = false;
      this.showClientTab = true;
      this.showNewAccount = true;
    },
    onChangeAccount(accountCode) {
      this.getAccount(accountCode);
    },
    someHandler() {
      this.btnDisable = false;
    },
    addClient() {
      this.clearClientForm();
      this.showAccountTab = false;
      this.showClientTab = true;
      this.aform.addAccount = false;
    },
    addAccount() {
      var clientCode = this.form.code;
      this.clearAccountForm();
      this.aform.code = clientCode;
      this.showAccountTab = true;
      this.showClientTab = false;
      this.aform.addAccount = true;
    },
    clearClientForm() {
      this.form.code = null;
      this.form.name = null;
      this.form.isAgent = false;
      this.form.postalName = null;
      this.form.postalAddress = null;
      this.form.postalSuburb = null;
      this.form.postalPostcode = null;
      this.form.phoneNumber = null;
      this.form.altPhoneNumber = null;
      this.form.mobileNumber = null;
      this.form.faxNumber = null;
      this.form.emailAddress = null;
      this.form.altEmailAddress = null;
      this.form.financeEmail = null;
      this.form.salesEmail = null;
      this.form.contactName = null;
      this.form.contactPhone = null;
      this.form.altContactName = null;
      this.form.altContactPhone = null;
      this.form.finContactName = null;
      this.form.finContactPhone = null;
      this.form.salesContactName = null;
      this.form.salesContactPhone = null;
      this.form.clientPic = null;
      this.form.clientLpaNum = null;
      this.form.bankName = null;
      this.form.bankAccName = null;
      this.form.bankBsb = null;
      this.form.bankAcc = null;
      this.form.tradingName = null;
      this.form.tradingAbn = null;
      this.form.gstRegistered = null;
      this.form.hobbyDecType = null;
      this.form.hobbyDecRef = null;
      this.form.agent = null;
      this.form.agentName = null;
      this.form.rep = null;
      this.form.status = null;
      this.form.addressName = null;
      this.form.address = null;
      this.form.town = null;
      this.form.postcode = null;
      this.form.gps = null;
      this.form.pic = null;
      this.form.columnPrefix = null;

      this.aform.accountId = null;
      this.aform.accountCode = null;
      this.aform.clientCode = null;
      this.aform.accountName = null;
      this.aform.vendClientName = null;
      this.aform.endClientPic = null;
      this.aform.vendorCapable = false;
      this.aform.useClientMail = false;
      this.aform.postalName = null;
      this.aform.postalAddress = null;
      this.aform.postalSuburb = null;
      this.aform.postalPostcode = null;
      this.aform.contactName = null;
      this.aform.contactPhone = null;
      this.aform.altContactName = null;
      this.aform.altContactPhone = null;
      this.aform.financeContactName = null;
      this.aform.financeContactPhone = null;
      this.aform.salesContactName = null;
      this.aform.salesContactPhone = null;
      this.aform.emailAddress = null;
      this.aform.altEmailAddress = null;
      this.aform.financeEmail = null;
      this.aform.salesEmail = null;
      this.aform.lpaNum = null;
      this.aform.stockCarrier = null;
      this.aform.useClientBank = false;
      this.aform.bankName = null;
      this.aform.bankAccName = null;
      this.aform.bankBsb = null;
      this.aform.bankAcc = null;
      this.aform.useClientBusinessDetails = false;
      this.aform.tradingName = null;
      this.aform.tradingAbn = null;
      this.aform.gstRegistered = false;
      this.aform.hobbyDecType = null;
      this.aform.hobbyDecRef = null;
      this.aform.agent = null;
      this.aform.agentName = null;
      this.aform.rep = null;
      this.aform.notes = null;
      this.aform.status = null;
      this.aform.slCode = null;
    },
    clearAccountForm() {
      this.aform.accountId = 0;
      this.aform.accountCode = null;
      this.aform.accountName = null;
      this.aform.endClientName = null;
      this.aform.endClientPic = null;
      this.aform.vendorCapable = false;
      this.aform.useClientMail = false;
      this.aform.postalName = null;
      this.aform.postalAddress = null;
      this.aform.postalSuburb = null;
      this.aform.postalPostcode = null;
      this.aform.contactName = null;
      this.aform.contactPhone = null;
      this.aform.altContactName = null;
      this.aform.altContactPhone = null;
      this.aform.financeContactName = null;
      this.aform.financeContactPhone = null;
      this.aform.salesContactName = null;
      this.aform.salesContactPhone = null;
      this.aform.emailAddress = null;
      this.aform.altEmailAddress = null;
      this.aform.financeEmail = null;
      this.aform.salesEmail = null;
      this.aform.lpaNum = null;
      this.aform.stockCarrier = null;
      this.aform.useClientBank = false;
      this.aform.bankName = null;
      this.aform.bankAccName = null;
      this.aform.bankBsb = null;
      this.aform.bankAcc = null;
      this.aform.useClientBusinessDetails = false;
      this.aform.tradingName = null;
      this.aform.tradingAbn = null;
      this.aform.gstRegistered = false;
      this.aform.hobbyDecType = null;
      this.aform.hobbyDecRef = null;
      this.aform.agent = null;
      this.aform.agentName = null;
      this.aform.rep = null;
      this.aform.notes = null;
      this.aform.status = 1;
      this.aform.slCode = null;
      this.aform.addAccount = true;
    },
    submitClientDetails(e) {
      var errorFound = false;

      this.phone = this.form.name;
      this.isLoading = true;

      this.errors = [];

      if (this.form.name.length < 3) {
        this.errors.push("Name must be greater than 3 characters.");
        errorFound = true;
      }

      if (this.form.agentName !== "" || this.form.agentRep !== "") {
        if (
          this.form.address === "" ||
          this.form.addressName === "" ||
          this.form.town === "" ||
          this.form.postcode === ""
        ) {
          this.errors.push("Property Address is required");
          errorFound = true;
        }
      }

      if (
        this.form.gstRegistered === false &&
        (document.getElementById("hobbyDecType").value === "" ||
          document.getElementById("hobbyDecRef").value === "")
      ) {
        this.errors.push("Hobby declaration is required");
        errorFound = true;
      }

      if (this.form.gstRegistered === true && this.form.tradingAbn === "") {
        this.errors.push("ABN is required");
        errorFound = true;
      }

      if (this.errors.length > 0) {
        return true;
      }

      e.preventDefault();
      errorFound = true;
      if (!errorFound) {
        if (this.saveClient()) {
          setTimeout(() => {
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: "Client information has been saved",
              queue: false
            });
          }, 500);
        }
      }
    },
    submitAccountDetails(e) {
      var errorFound = false;

      this.errorsAccount = [];

      if (this.aform.accountName.length < 3) {
        this.errorsAccount.push("Name must be greater than 3 characters.");
        errorFound = true;
      }

      if (this.aform.agentName !== "" || this.aform.agentRep !== "") {
        if (
          this.aform.address === "" ||
          this.aform.addressName === "" ||
          this.aform.town === "" ||
          this.aform.postcode === ""
        ) {
          this.errorsAccount.push("Property Address is required");
          errorFound = true;
        }
      }

      if (
        this.aform.gstRegistered === false &&
        (document.getElementById("hobbyDecType").value === "" ||
          document.getElementById("hobbyDecRef").value === "")
      ) {
        this.errorsAccount.push("Hobby declaration is required");
        errorFound = true;
      }

      if (this.aform.gstRegistered === true && this.aform.tradingAbn === "") {
        this.errorsAccount.push("ABN is required");
        errorFound = true;
      }

      if (this.errorsAccount.length > 0) {
        return true;
      }

      if (this.aform.addAccount) {
        // assign the account code '-' for first account and then 1 for next account and then 2 etc
        if (this.aform.accountCode === "") {
          this.aform.accountCode = "-";
        } else {
          var x = "";
          var currentCode = "";
          for (x in this.accounts) {
            currentCode = this.accounts[x].accountCode;
          }
          if (currentCode === "-") {
            this.aform.accountCode = 1;
          } else {
            this.aform.accountCode = parseInt(currentCode) + 1;
          }
        }
      }

      e.preventDefault();
      if (!errorFound) {
        if (this.saveAccount()) {
          this.getClientData(this.form.code);
          setTimeout(() => {
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: "Account information has been saved",
              queue: false
            });
          }, 500);
        }
      }
    },
    checkClientForm() {
      var missingData = false;
      // if adding new client then check if we have all fields
      // if (document.getElementById('code') !== '') {
      if (document.getElementById("name").value === "") {
        missingData = true;
      }
      if (document.getElementById("postalName").value === "") {
        missingData = true;
      }
      if (document.getElementById("postalAddress").value === "") {
        missingData = true;
      }
      if (document.getElementById("postalSuburb").value === "") {
        missingData = true;
      }
      if (document.getElementById("postalPostcode").value === "") {
        missingData = true;
      }
      if (document.getElementById("phoneNumber").value === "") {
        missingData = true;
      }
      if (document.getElementById("mobileNumber").value === "") {
        missingData = true;
      }
      if (document.getElementById("emailAddress").value === "") {
        missingData = true;
      }
      if (document.getElementById("contactName").value === "") {
        missingData = true;
      }
      if (document.getElementById("contactPhone").value === "") {
        missingData = true;
      }
      // if (document.getElementById('altContactName').value === '') { missingData = true }
      // if (document.getElementById('altContactPhone').value === '') { missingData = true }
      // if (document.getElementById('financeContactName').value === '') { missingData = true }
      // if (document.getElementById('financeContactPhone').value === '') { missingData = true }
      // if (document.getElementById('salesContactName').value === '') { missingData = true }
      // if (document.getElementById('salesContactPhone').value === '') { missingData = true }
      // if (document.getElementById('clientLpaNum').value === '') { missingData = true }
      if (document.getElementById("clientPic").value === "") {
        missingData = true;
      }
      if (document.getElementById("bankName").value === "") {
        missingData = true;
      }
      if (document.getElementById("bankAccName").value === "") {
        missingData = true;
      }
      if (document.getElementById("bankBsb").value === "") {
        missingData = true;
      }
      if (document.getElementById("bankAcc").value === "") {
        missingData = true;
      }
      if (document.getElementById("addressName").value === "") {
        missingData = true;
      }
      if (document.getElementById("address").value === "") {
        missingData = true;
      }
      if (document.getElementById("town").value === "") {
        missingData = true;
      }
      if (document.getElementById("postcode").value === "") {
        missingData = true;
      }
      // if (document.getElementById('pic').value === '') { missingData = true }

      if (!missingData) {
        this.isClientSaveEnabled = true;
      } else {
        this.isClientSaveEnabled = false;
      }
    },
    useClientAddress() {
      if (this.aform.useClientAddress) {
        this.aform.postalName = this.form.postalName;
        this.aform.postalAddress = this.form.postalAddress;
        this.aform.postalSuburb = this.form.postalSuburb;
        this.aform.postalPostcode = this.form.postalPostcode;
      } else {
        this.aform.postalName = "";
        this.aform.postalAddress = "";
        this.aform.postalSuburb = "";
        this.aform.postalPostcode = "";
      }
    },
    useClientBank() {
      if (this.aform.useClientBank) {
        this.aform.bankName = this.form.bankName;
        this.aform.bankBsb = this.form.bankBsb;
        this.aform.bankAccName = this.form.bankAccName;
        this.aform.bankAcc = this.form.bankAcc;
      } else {
        this.aform.bankName = "";
        this.aform.bankBsb = "";
        this.aform.bankAccName = "";
        this.aform.bankAcc = "";
      }
    },
    useClientBusiness() {
      if (this.aform.useClientBusinessDetails) {
        this.aform.tradingName = this.form.tradingName;
        this.aform.tradingAbn = this.form.tradingAbn;
        this.aform.gstRegistered = this.form.gstRegistered;
      } else {
        this.aform.tradingName = "";
        this.aform.tradingAbn = "";
        this.aform.gstRegistered = "";
      }
    },
    checkAccountForm() {
      // if adding new account then check if we have all fields
      var missingData = false;
      if (document.getElementById("aAccountName").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPostalName").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPostalAddress").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPostalSuburb").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPostalPostcode").value === "") {
        missingData = true;
      }
      if (document.getElementById("aContactPhone").value === "") {
        missingData = true;
      }
      if (document.getElementById("aEmailAddress").value === "") {
        missingData = true;
      }
      if (document.getElementById("aContactName").value === "") {
        missingData = true;
      }
      // if (document.getElementById('aContactPhone').value === '') { missingData = true }
      if (document.getElementById("aBankName").value === "") {
        missingData = true;
      }
      if (document.getElementById("aBankAccName").value === "") {
        missingData = true;
      }
      if (document.getElementById("aBankBsb").value === "") {
        missingData = true;
      }
      if (document.getElementById("aBankAcc").value === "") {
        missingData = true;
      }
      if (document.getElementById("aAddressName").value === "") {
        missingData = true;
      }
      if (document.getElementById("aAddress").value === "") {
        missingData = true;
      }
      if (document.getElementById("aTown").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPostcode").value === "") {
        missingData = true;
      }
      if (document.getElementById("aPic").value === "") {
        missingData = true;
      }
      if (!missingData) {
        this.isAccountSaveEnabled = true;
      } else {
        this.isAccountSaveEnabled = false;
      }
    },
    async saveClient() {
      if (this.form.code === "") {
        var clientCode = "";
        clientCode = this.client.name.substring(4);
        var found = this.clients.filter(function(search) {
          return search.clientCode === this.client.name.substring(4);
        });
        if (found) {
          clientCode = this.client.name.substring(5);
        }
        found = this.clients.filter(function(search) {
          return search.clientCode === clientCode;
        });
        if (found) {
          clientCode = this.client.name.substring(6);
        }
        this.postClient(clientCode);
      } else {
        this.putClient();
      }
    },
    async saveAccount() {
      if (this.aform.addAccount) {
        this.postAccount();
      } else {
        this.putAccount();
      }
    },
    async putClient() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "client/" + this.form.code,
          {
            action: "ClPutClient",
            changedFields: {
              name: this.form.name,
              postalName: this.form.postalName,
              postalAddress: this.form.postalAddress,
              postalSuburb: this.form.postalSuburb,
              postalPostcode: this.form.postalPostcode,
              phoneNumber: this.form.phoneNumber,
              altPhoneNumber: this.form.altPhoneNumber,
              mobileNumber: this.form.mobileNumber,
              faxNumber: this.form.faxNumber,
              emailAddress: this.form.emailAddress,
              altEmailAddress: this.form.altEmailAddress,
              financeEmail: this.form.financeEmail,
              salesEmail: this.form.salesEmail,
              contactName: this.form.contactName,
              contactPhone: this.form.contactPhone,
              altContactName: this.form.altContactName,
              altContactPhone: this.form.altContactPhone,
              financeContactName: this.form.financeContactName,
              financeContactPhone: this.form.financeContactPhone,
              salesContactName: this.form.salesContactName,
              salesContactPhone: this.form.salesContactPhone,
              clientPic: this.form.clientPic,
              clientLpaNum: this.form.clientLpaNum,
              bankName: this.form.bankName,
              bankAccName: this.form.bankAccName,
              bankBsb: this.form.bankBsb,
              bankAcc: this.form.bankAcc,
              tradingName: this.form.tradingName,
              tradingAbn: this.form.tradingAbn,
              gstRegistered: this.form.gstRegistered,
              hobbyDecType: this.form.hobbyDecType,
              hobbyDecRef: this.form.hobbyDecRef,
              agent: this.form.agent,
              agentName: this.form.agentName,
              agent_id: this.form.isAgent,
              rep: this.form.rep,
              status: this.form.status,
              defaultAddress: {
                addressName: this.form.addressName,
                address: this.form.address,
                town: this.form.town,
                postcode: this.form.postcode,
                gps: this.form.gps,
                pic: this.form.pic,
                columnPrefix: this.form.columnPrefix
              }
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        console.log("cid");
      } catch (error) {
        console.log(error);
      }
    },
    async postClient(clientCode) {
      try {
        await axios.post(
          this.$store.state.apiUrl + "client?mode=app" + this.form.code,
          {
            code: clientCode,
            name: this.form.name,
            postalName: this.form.postalName,
            postalAddress: this.form.postalAddress,
            postalSuburb: this.form.postalSuburb,
            postalPostcode: this.form.postalPostcode,
            phoneNumber: this.form.phoneNumber,
            altPhoneNumber: this.form.altPhoneNumber,
            mobileNumber: this.form.mobileNumber,
            faxNumber: this.form.faxNumber,
            emailAddress: this.form.emailAddress,
            altEmailAddress: this.form.altEmailAddress,
            financeEmail: this.form.financeEmail,
            salesEmail: this.form.salesEmail,
            contactName: this.form.contactName,
            contactPhone: this.form.contactPhone,
            altContactName: this.form.altContactName,
            altContactPhone: this.form.altContactPhone,
            financeContactName: this.form.financeContactName,
            financeContactPhone: this.form.financeContactPhone,
            salesContactName: this.form.salesContactName,
            salesContactPhone: this.form.salesContactPhone,
            clientPic: this.form.clientPic,
            clientLpaNum: this.form.clientLpaNum,
            bankName: this.form.bankName,
            bankAccName: this.form.bankAccName,
            bankBsb: this.form.bankBsb,
            bankAcc: this.form.bankAcc,
            tradingName: this.form.tradingName,
            tradingAbn: this.form.tradingAbn,
            gstRegistered: this.form.gstRegistered,
            hobbyDecType: this.form.hobbyDecType,
            hobbyDecRef: this.form.hobbyDecRef,
            agent: this.form.agent,
            agentName: this.form.agentName,
            rep: this.form.rep,
            status: 1,
            defaultAddress: {
              addressName: this.form.addressName,
              address: this.form.address,
              town: this.form.town,
              postcode: this.form.postcode,
              gps: this.form.gps,
              pic: this.form.pic,
              columnPrefix: this.form.columnPrefix
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        console.log("cid");
      } catch (error) {
        console.log(error);
      }
    },
    async postAccount() {
      try {
        await axios.post(
          this.$store.state.apiUrl + "client_account?mode=app",
          {
            clientCode: this.aform.code,
            accountCode: this.aform.accountCode,
            accountName: this.aform.accountName,
            endClientName: this.aform.endClientName,
            endClientPic: this.aform.endClientPic,
            vendorCapable: this.aform.vendorCapable,
            useClientMail: this.aform.useClientMail,
            postalName: this.aform.postalName,
            postalAddress: this.aform.postalAddress,
            postalSuburb: this.aform.postalSuburb,
            postalPostcode: this.aform.postalPostcode,
            phoneNumber: this.aform.phoneNumber,
            altPhoneNumber: this.aform.altPhoneNumber,
            mobileNumber: this.aform.mobileNumber,
            faxNumber: this.aform.faxNumber,
            emailAddress: this.aform.emailAddress,
            altEmailAddress: this.aform.altEmailAddress,
            financeEmail: this.aform.financeEmail,
            salesEmail: this.aform.salesEmail,
            contactName: this.aform.contactName,
            contactPhone: this.aform.contactPhone,
            altContactName: this.aform.altContactName,
            altContactPhone: this.aform.altContactPhone,
            financeContactName: this.aform.financeContactName,
            financeContactPhone: this.aform.financeContactPhone,
            salesContactName: this.aform.salesContactName,
            salesContactPhone: this.aform.salesContactPhone,
            lpaNum: this.aform.lpaNum,
            useClientBank: this.aform.useClientBank,
            bankName: this.aform.bankName,
            bankAccName: this.aform.bankAccName,
            bankBsb: this.aform.bankBsb,
            bankAcc: this.aform.bankAcc,
            useClientBusinessDetails: this.aform.useClientBusinessDetails,
            tradingName: this.aform.tradingName,
            tradingAbn: this.aform.tradingAbn,
            gstRegistered: this.aform.gstRegistered,
            hobbyDecType: this.aform.hobbyDecType,
            hobbyDecRef: this.aform.hobbyDecRef,
            agent: this.aform.agent,
            agentName: this.aform.agentName,
            stockCarrier: this.aform.stockCarrier,
            status: 1,
            rep: this.aform.rep,
            slCode: this.aform.slCode,
            address: {
              addressName: this.aform.addressName,
              address: this.aform.address,
              town: this.aform.town,
              postcode: this.aform.postcode,
              gps: this.aform.gps,
              pic: this.aform.pic,
              columnPrefix: this.aform.columnPrefix
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        console.log("cid");
      } catch (error) {
        console.log(error);
      }
    },
    async putAccount() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "client_account/" + this.aform.accountId,
          {
            action: "CaPutClientAccount",
            changedFields: {
              clientCode: this.aform.code,
              accountCode: this.aform.accountCode,
              accountName: this.aform.accountName,
              endClientName: this.aform.endClientName,
              endClientPic: this.aform.endClientPic,
              vendorCapable: this.aform.vendorCapable,
              useClientMail: this.aform.useClientMail,
              postalName: this.aform.postalName,
              postalAddress: this.aform.postalAddress,
              postalSuburb: this.aform.postalSuburb,
              postalPostcode: this.aform.postalPostcode,
              phoneNumber: this.aform.phoneNumber,
              altPhoneNumber: this.aform.altPhoneNumber,
              mobileNumber: this.aform.mobileNumber,
              faxNumber: this.aform.faxNumber,
              emailAddress: this.aform.emailAddress,
              altEmailAddress: this.aform.altEmailAddress,
              financeEmail: this.aform.financeEmail,
              salesEmail: this.aform.salesEmail,
              contactName: this.aform.contactName,
              contactPhone: this.aform.contactPhone,
              altContactName: this.aform.altContactName,
              altContactPhone: this.aform.altContactPhone,
              financeContactName: this.aform.financeContactName,
              financeContactPhone: this.aform.financeContactPhone,
              salesContactName: this.aform.salesContactName,
              salesContactPhone: this.aform.salesContactPhone,
              useClientBank: this.aform.useClientBank,
              bankName: this.aform.bankName,
              bankAccName: this.aform.bankAccName,
              bankBsb: this.aform.bankBsb,
              bankAcc: this.aform.bankAcc,
              lpaNum: this.aform.lpaNum,
              useClientBusinessDetails: this.aform.useClientBusinessDetails,
              tradingName: this.aform.tradingName,
              tradingAbn: this.aform.tradingAbn,
              gstRegistered: this.aform.gstRegistered,
              hobbyDecType: this.aform.hobbyDecType,
              hobbyDecRef: this.aform.hobbyDecRef,
              agent: this.aform.agent,
              agentName: this.aform.agentName,
              stockCarrier: this.aform.stockCarrier,
              status: this.aform.status,
              rep: this.aform.rep,
              slCode: this.aform.slCode,
              address: {
                addressName: this.aform.addressName,
                address: this.aform.address,
                town: this.aform.town,
                postcode: this.aform.postcode,
                gps: this.aform.gps,
                pic: this.aform.pic,
                columnPrefix: this.aform.columnPrefix
              }
            }
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        console.log("cid");
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getClients();
  },
  mounted() {
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   map.panTo({ lat: -34.9285, lng: 138.6007 })
    // })
    // this.sortArrays(
  }
};
</script>
